module.exports = __webpack_public_path__ + "static/media/autochilango-star.e0022de0.svg";